<div mat-dialog-content class="mat-dialog-content">
  <img src="{{image}}" alt="Participant Documents" class="popup_img">
</div>